import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { TextField, Button, Stack, Typography } from "@mui/material";
import { useLanguage } from '../context/LanguageContext.js';
import { logDev } from "../utils/logger.js";

const ResetPasswords = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const groupeId = searchParams.get("groupe");
  const token = searchParams.get("token");
  const [motdepasseAdmin, setMotdepasseAdmin] = useState("");
  const [motdepasseUtilisateur, setMotdepasseUtilisateur] = useState("");
  const [message, setMessage] = useState("");

  const handleReset = async () => {
    // Vérifie que les deux mots de passe sont différents
  if (motdepasseAdmin === motdepasseUtilisateur) {
    setMessage(`❌ ${t('AdminAndUserPasswordMustBeDifferent')}`);
    
    return;
  }

    try {
      const res = await axios.put(`${process.env.REACT_APP_API}/groupes/${groupeId}/reset-passwords`, {
        token,
        motdepasseAdmin,
        motdepasseUtilisateur
      });

      if (res.data.success) {
        setMessage(`✅ ${t('PasswordReset')}`);
        setTimeout(() => navigate("/"), 2000);
      } else {
        setMessage("❌ Échec : " + res.data.message);
      }
    } catch (err) {
      logDev("❌ Erreur réinitialisation mots de passe", { message: err.message, stack: err.stack });
      setMessage(`❌ ${t('ServerError')}`);
      
    }
  };

  return (
    <Stack spacing={2} sx={{ maxWidth: 400, margin: "auto", mt: 8 }}>
      <Typography variant="h5">🔐 {t('PasswordReinit')}</Typography>

      <TextField
        label= {t('NewAdminPassword')}
        type="password"
        value={motdepasseAdmin}
        onChange={(e) => setMotdepasseAdmin(e.target.value)}
        sx={{ backgroundColor: "#fff", borderRadius: 1 }}
      />

      <TextField
        label={t('NewUsersPassword')}
        type="password"
        value={motdepasseUtilisateur}
        onChange={(e) => setMotdepasseUtilisateur(e.target.value)}
        sx={{ backgroundColor: "#fff", borderRadius: 1 }}
      />

      <Button variant="contained" onClick={handleReset}>
        {t('Validate')}
      </Button>

      {message && <Typography color="error">{message}</Typography>}
    </Stack>
  );
};

export default ResetPasswords;
